import { Head, Link } from "@inertiajs/react";
import { Box, Button, Stack } from "@mantine/core";
import AppShell from "../../Components/Layout/AppShell";
import PostDetail from "../PostDetail";
import { Heading1, DimmedText } from "../../Components/UI/Typography";
import { getPostBySlug } from "../../data/posts";

interface Props {
  slug: string;
}

/** Route wrapper for /tech/posts/:slug — delegates to universal PostDetail. */
export default function TechPostShow({ slug }: Props) {
  const post = getPostBySlug("tech", slug);

  if (!post) {
    return (
      <AppShell>
        <Head>
          <title>Post Not Found | Ogarocious</title>
        </Head>
        <Box
          style={{
            minHeight: "100vh",
            background:
              "linear-gradient(180deg, #0a0705 0%, #0f0b08 50%, #0a0705 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack align="center" gap="md">
            <Heading1>Post Not Found</Heading1>
            <DimmedText>
              That post doesn&apos;t exist or has been removed.
            </DimmedText>
            <Button variant="gradient" component={Link} href="/tech">
              Back to Tech
            </Button>
          </Stack>
        </Box>
      </AppShell>
    );
  }

  return <PostDetail post={post} />;
}
